import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as landlordAPIDashboardActions from 'actions/landlordAPIDashboardActions';

import DocumentStatus from 'components/shared/DocumentStatus';

import JSONTree from 'react-json-tree';

import { colors } from 'helpers/ColorHelper';

import Collapsible from 'components/shared/Collapsible';

export class DocumentInformation extends Component {
  UNSAFE_componentWillMount() {
    this.props.clearDocument();
    this.props.viewDocumentInformation(this.props.mode, this.props.uuid);
  }

  renderSigners = (signers) => {
    return signers.map((signer, index) => {
      return (
        <div className="row" style={{ marginTop: '5px' }} key={`${signer.email}.${index}`}>
          <div className="col-xs-2" name={`signer-firstname-${index + 1}`}>
            {signer.is_agent ? `(Agent) ${signer.first_name}` : signer.first_name}
          </div>
          <div className="col-xs-2">{signer.last_name}</div>
          <div className="col-xs-4">{signer.email}</div>
          <div className="col-xs-2">{signer.signature_type}</div>
          <div className="col-xs-2">{signer.signatures_completed === true ? 'Yes' : 'No'}</div>
        </div>
      );
    });
  };

  render() {
    const style = {
      table_header: {
        margin: '30px 0px 10px 0px',
        backgroundColor: colors.LIGHT_GRAY,
        fontSize: '14px',
      },
    };

    return (
      <div>
        {this.props.document && (
          <div>
            {this.props.document.whitelabeling && (
              <div>
                <h4 style={{ textAlign: 'center' }}>UUID: {this.props.document.uuid}</h4>
                <div style={{ textAlign: 'center' }}>
                  <DocumentStatus status={this.props.document.status} />
                </div>
                <div className="row" style={style.table_header}>
                  <div style={{ padding: '5px 10px 25px 15px' }}>
                    <span style={{ textAlign: 'center', float: 'left' }}>WHITELABELING</span>
                  </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="row">
                    <div className="col-xs-3">
                      <h6 style={{ marginBottom: '5px' }}> Site Name </h6>
                    </div>
                    <div className="col-xs-3">
                      <h6 style={{ marginBottom: '5px' }}> Company Name </h6>
                    </div>
                    <div className="col-xs-3">
                      <h6 style={{ marginBottom: '5px' }}> Primary Logo </h6>
                    </div>
                    <div className="col-xs-3">
                      <h6 style={{ marginBottom: '5px' }}> Phone Number </h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-3">{this.props.document.whitelabeling.site_name}</div>
                    <div className="col-xs-3">{this.props.document.whitelabeling.company_name}</div>
                    <div className="col-xs-3">{this.props.document.whitelabeling.primary_logo}</div>
                    <div className="col-xs-3">
                      {this.props.document.whitelabeling.primary_phone_number}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row" style={style.table_header}>
              <div style={{ padding: '5px 10px 25px 15px' }}>
                <span style={{ textAlign: 'center', float: 'left' }}>SIGNERS</span>
              </div>
            </div>

            <div className="row" style={{ marginTop: '20px' }}>
              <div className="row">
                <div className="col-xs-2">
                  <h6 style={{ marginBottom: '5px' }}> First Name </h6>
                </div>
                <div className="col-xs-2">
                  <h6 style={{ marginBottom: '5px' }}> Last Name </h6>
                </div>
                <div className="col-xs-4">
                  <h6 style={{ marginBottom: '5px' }}> Email </h6>
                </div>
                <div className="col-xs-2">
                  <h6 style={{ marginBottom: '5px' }}> Signature Type </h6>
                </div>
                <div className="col-xs-2">
                  <h6 style={{ marginBottom: '5px' }}> Signature Complete </h6>
                </div>
              </div>
              {this.renderSigners(this.props.document.signers)}
            </div>

            <div className="row" style={style.table_header}>
              <div style={{ padding: '5px 10px 25px 15px' }}>
                <span style={{ textAlign: 'center', float: 'left' }}>METADATA</span>
              </div>
            </div>

            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col" style={{ marginTop: '10px' }}>
                <JSONTree data={this.props.document.metadata} />
              </div>
            </div>

            <Collapsible
              header={
                <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                  <div className="col-xs-6" style={style.bold_padding}>
                    <p id="no-margin" name={`events-title`}>
                      EVENTS ({this.props.document.events.length})
                    </p>
                  </div>
                </div>
              }
            >
              <div className="row" style={{ marginTop: '5px' }}>
                <div className="col" style={{ marginTop: '10px' }}>
                  <JSONTree data={this.props.document.events} />
                </div>
              </div>
            </Collapsible>
          </div>
        )}
      </div>
    );
  }
}

export default connect((store) => {
  return {
    document: store.landlordAPIDashboard.document,
  };
}, landlordAPIDashboardActions)(DocumentInformation);
